import React from "react";
import { FaBars } from "react-icons/fa";
import { BiChevronDown } from "react-icons/bi";
import PatientHomePage from "../pages/hcp/patients_home_page";
import { Redirect, Route, Switch } from "react-router-dom";
import ClinicalSites from "../pages/admin/ClinicalSites";
import ClinicalSiteHomepage from "../pages/admin/ClinicalSiteHomepage";
import AdminProfileLayout from "../layout/AdminProfileLayout";
import { Line } from "recharts";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AdminDashboard from "../pages/admin/Dashboard";
import ManageUsers from "../pages/admin/ManageUsers";
import ManageFunctionalChecklists from "../pages/admin/ManageFunctionalChecklists";
import { useAuth } from "../services/authProvider";
import CreateCustomFunctionalChecklist from "../pages/admin/CreateCustomFunctionalChecklist";
import ManagePatients from "../pages/admin/ManagePatients";
import ManageAdmissions from "../pages/admin/ManageAdmissions";
import ViewChecklist from "../pages/admin/ViewChecklist";
import AdminPatientHomePage from "../pages/admin/AdminPatientHomePage";
import AdminUserDetails from "../pages/admin/AdminUserDetails";

const MainAdmin = ({ handleCollapsedChange }) => {
  const { logout } = useAuth();
  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <main className="h-100">
      <nav class="navbar navbar-expand-lg navbar-white bg-white shadow-sm pr-4 py-4">
        <span>
          {/* <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
                <FaBars />
            </div> */}
          <button className="btn toggle-btn" onClick={handleCollapsedChange}>
            <FaBars />
          </button>
        </span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li className="nav-item px-4 d-flex align-items-center">
              <a href="#" className="text_small mr-4">
                {user?.organizations.length > 0
                  ? user?.organizations.filter(org=>org.active)[0]?.name
                  : ""}
              </a>
            </li>
            <li class="nav-item dropdown pr-2 ">
              <a
                class="navbar-btn px-2 rounded d-flex align-items-center justify-content-center text_small text-decoration-none"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                {user?.lastName}, {user?.firstName}{" "}
                {user?.organizations[0].careProvider
                  ? `: ${user?.organizations[0].careProvider.position.abbreviation}`
                  : ""}
                <BiChevronDown size={30} className="navbar-btn-icon" />
              </a>
              <div
                class="dropdown-menu w-small dropdown-menu-right pl-0 ml-0"
                aria-labelledby="navbarDropdown"
              >
                <Link
                  class="dropdown-item ml-0 pl-3 text_small"
                  to={"/admin/profile/personal_details"}
                >
                  <i className="fa fa-user" /> &nbsp;Profile
                </Link>
                <Link
                  class="dropdown-item ml-0 pl-3 text_small"
                  to="/admin/profile/change_password"
                >
                  <i className="fa fa-key" /> &nbsp;Change Password
                </Link>
                <a
                  class="dropdown-item ml-0 pl-3 text_small"
                  href="#"
                  onClick={() => {
                    logout();
                  }}
                >
                  <i className="fa fa-sign-out" /> &nbsp;Logout
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <Switch>
        <Route path="/admin/dashboard" component={AdminDashboard} />
        <Route path="/admin/clinicalsites" component={ClinicalSites} />
        <Route
          path="/admin/clinical_site/details/:id"
          component={ClinicalSiteHomepage}
        />
        <Route path="/admin/manage_users" component={ManageUsers} />
        <Route
          path="/admin/manage_functional_checklists"
          component={ManageFunctionalChecklists}
        />
        <Route path="/admin/manage_admissions" component={ManageAdmissions} />
        <Route path="/admin/profile" component={AdminProfileLayout} />
        <Route path="/admin/manage_patients" component={ManagePatients} />
        <Route
          path="/admin/create_custom_functional_checklist"
          component={CreateCustomFunctionalChecklist}
        />
        <Route path="/admin/view_checklist" component={ViewChecklist} />
        <Route
          path="/admin/patient/details/:pommeId"
          component={AdminPatientHomePage}
        />
        <Route
          path="/admin/user/details/:userId"
          component={AdminUserDetails}
        />
        <Redirect from="/admin" to={"/admin/clinicalsites"} />
      </Switch>
    </main>
  );
};

export default MainAdmin;
